import { render, staticRenderFns } from "./ControlBuildProtocolButton.vue?vue&type=template&id=636b46c2"
import script from "./ControlBuildProtocolButton.vue?vue&type=script&lang=js"
export * from "./ControlBuildProtocolButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports